"use strict";
/* Generated from:
 * ap-southeast-2 (https://d2stg8d246z9di.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ca-central-1 (https://d2s8ygphhesbe7.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * eu-west-2 (https://d1742qcu2c1ncx.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * us-east-1 (https://d1uauaxba7bl26.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * us-west-2 (https://d201a2mn26r7lk.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
const resource_1 = require("../resource");
class StreamConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.StreamConfiguration = StreamConfiguration;
class LaunchProfile extends resource_1.ResourceBase {
    constructor(properties) {
        super('AWS::NimbleStudio::LaunchProfile', properties);
    }
}
exports.default = LaunchProfile;
LaunchProfile.StreamConfiguration = StreamConfiguration;
